define('areas/home/services/livetilecache',["require", "exports", "durandal/app", "services/httpclient", "services/trace", "areas/home/model/livetilecacheitem", "areas/home/model/livetilerequest"], function (require, exports, App, Http, Trace, LiveTileCacheItem, LiveTileRequest) {
    "use strict";
    var LiveTileCache = (function () {
        function LiveTileCache() {
            var _this = this;
            App.on("refreshTileData", (function (x) { return _this.updateTileData(x); }), this);
            this.runAutoUpdate();
        }
        LiveTileCache.prototype.request = function (dataKey, handler) {
            var _this = this;
            var request = new LiveTileRequest();
            request.key = dataKey;
            request.handler = handler;
            // unnötige Calls verhindern
            var cachedItem = this.findCacheItem(request.key);
            if (cachedItem !== null && !cachedItem.isInvalidated)
                return;
            // in die Task-Kette legen
            LiveTileCache._requests.push(request);
            if (LiveTileCache._requests.length === 1) {
                window.setTimeout(function () { _this.fetchTileData(); }, 0);
            }
        };
        LiveTileCache.prototype.updateTileData = function (dataKey) {
            var cachedItem = this.findCacheItem(dataKey);
            if (cachedItem !== null) {
                cachedItem.isInvalidated = true;
                this.request(dataKey, cachedItem.handler);
            }
        };
        LiveTileCache.prototype.fetchTileData = function () {
            var channel = new Http.Channel();
            while (LiveTileCache._requests.length > 0) {
                var request = LiveTileCache._requests.pop();
                var cachedItem = this.findCacheItem(request.key);
                if (cachedItem == null || cachedItem.isInvalidated) {
                    channel.getData("/api/tiles/" + request.key, Http.ServiceTarget.portalApi)
                        .then(function (result) {
                        if (cachedItem == null) {
                            cachedItem = new LiveTileCacheItem();
                            cachedItem.key = request.key;
                            cachedItem.handler = request.handler; // TODO: Muss das evtl. eine Auflistung sein?
                            LiveTileCache._items.push(cachedItem);
                        }
                        cachedItem.isInvalidated = false;
                        cachedItem.data = result;
                    })
                        .fail(function (reason) {
                        var alertMessage = $.t("app:modules.home.message_loadDetailsFailed", { ifMissing: "Fehler beim Laden der Detaildaten: " });
                        Trace.traceError(alertMessage + reason, null, request.key, true);
                    });
                }
                if (cachedItem !== null)
                    cachedItem.handler(cachedItem.data);
            }
        };
        LiveTileCache.prototype.findCacheItem = function (dataKey) {
            return Enumerable.From(LiveTileCache._items)
                .FirstOrDefault(null, function (x) { return x.key === dataKey; });
        };
        LiveTileCache.prototype.runAutoUpdate = function () {
            var _this = this;
            if (LiveTileCache._autoUpdateIsRunning === false) {
                LiveTileCache._autoUpdateIsRunning = true;
                Enumerable.From(LiveTileCache._items)
                    .ForEach(function (x) { return _this.updateTileData(x.key); });
                setTimeout(function () { _this.runAutoUpdate(); }, 5 * 60000); // alle 5min
            }
        };
        LiveTileCache._invalid = true;
        LiveTileCache._items = [];
        LiveTileCache._requests = [];
        LiveTileCache._autoUpdateIsRunning = false;
        return LiveTileCache;
    }());
    return LiveTileCache;
});

